import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../styles/ReturningUserPage.css";

const ResetPasswordPage = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setSuccessMessage("");
    setErrorMessage("");

    // simple client-side check
    if (!newPassword || newPassword.length < 6) {
      setErrorMessage("please choose a password with at least 6 characters.");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(
        `https://squid-app-6s2hc.ondigitalocean.app/reset-password/${token}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ new_password: newPassword }),
        }
      );
      const data = await response.json();

      if (data.success) {
        setSuccessMessage("password reset. please log in.");
        setSubmitted(true);

        // clear any stale session so the next step is a clean login
        sessionStorage.removeItem("loginIdentifier");
        sessionStorage.removeItem("userName");
        sessionStorage.removeItem("hasCollection");
        sessionStorage.removeItem("hasPublishedCollection");

        // go to Returning (login)
        setTimeout(() => {
          navigate("/returning", { replace: true });
        }, 600);
      } else {
        setErrorMessage(data.message || "something went wrong.");
      }
    } catch {
      setErrorMessage("an error occurred. please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="forgot-password-page">
       <div className="returning-wrap">
      {/* noValidate disables native tooltip */}
      <form onSubmit={handleResetPassword} className="forgot-password-form" noValidate>
       <div className="input-group password-row">
  <label htmlFor="newPassword" className="sr-only">
    new password
  </label>

  <input
    id="newPassword"
    type={showPw ? "text" : "password"}
    value={newPassword}
    onChange={(e) => {
      setNewPassword(e.target.value);
      setErrorMessage("");
    }}
    placeholder="enter a new password"
    className={errorMessage ? "has-error" : ""}
    aria-invalid={!!errorMessage}
    autoComplete="new-password"
  />

  <button
    type="button"
    className="pw-toggle"
    onClick={() => setShowPw((v) => !v)}
    aria-label={showPw ? "hide password" : "show password"}
    aria-pressed={showPw}
    title={showPw ? "hide password" : "show password"}
  >
    {showPw ? "hide" : "show"}
  </button>
</div>

        {successMessage && <p className="success-message">{successMessage}</p>}
        {errorMessage && <p className="error-message">{errorMessage}</p>}

        <button
          type="submit"
          className="submit-button"
          disabled={submitted || loading}
        >
          {submitted ? "password reset" : loading ? "saving..." : "reset password"}
        </button>
      </form>
    </div>
    </main>
  );
};

export default ResetPasswordPage;
